import React from 'react';
import { Field } from 'redux-form';

import ImageContainer from './ImageContainer';

const Image = props => <Field {...props} component={ImageContainer} />;

export default Image;
